import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  foodItems: null,
};

const productSlice = createSlice({
  name: "product",
  initialState: initialState,
  reducers: {
    setFoodItems(state, action) {
      state.foodItems = action.payload;
    },
  },
});

export const { setFoodItems} = productSlice.actions;

export default productSlice.reducer;
